var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 2.44531L18.4609 18.6562C18.4219 19.0469 18.1875 19.3984 17.8359 19.5938C17.6406 19.6719 17.4453 19.75 17.2109 19.75C17.0547 19.75 16.8984 19.7109 16.7422 19.6328L11.9766 17.6406L9.98438 20.6094C9.82812 20.8828 9.55469 21 9.28125 21C8.85156 21 8.5 20.6484 8.5 20.2188V16.4688C8.5 16.1562 8.57812 15.8828 8.73438 15.6875L17.25 4.75L5.76562 15.1016L1.74219 13.4219C1.3125 13.2266 1 12.8359 1 12.3281C0.960938 11.7812 1.19531 11.3906 1.625 11.1562L19.125 1.19531C19.5156 0.960938 20.0625 0.960938 20.4531 1.23438C20.8438 1.50781 21.0391 1.97656 20.9609 2.44531Z",
    fill: "#B46C9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.29e75dcff337804da081320f0ea95441.svg";
export { ForwardRef as ReactComponent };